import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=afc7b58e&scoped=true"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"
import style0 from "./Builder.vue?vue&type=style&index=0&id=afc7b58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc7b58e",
  null
  
)

export default component.exports